module.exports = __webpack_public_path__ + "static/img/icon_01@2x.ae3b4f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry-version/icon_01@2x.png
// module id = 919
// module chunks = 2